<template>
	<div id="app">
		<Header></Header>
		<keep-alive>
		   <router-view v-if='$route.meta.keepAlive'></router-view>
		</keep-alive>
		<router-view v-if='!$route.meta.keepAlive'></router-view>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	export default {
		name: 'App',
		data() {
			return {

			}
		},
		components: {
			Header,
			Footer
		},
		mounted() {
			// this.$router.afterEach((to, from, next) => {
			// 	window.scrollTo(0, 0)
			// })
		}
	}
</script>

<style>
	#app {
		font-family: "PingFang SC", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", Helvetica, Arial, "Hiragino Sans GB", "Source Han Sans", "Noto Sans CJK Sc", "Microsoft YaHei", "Microsoft Jhenghei", sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		-webkit-tap-highlight-color: transparent;
		background-color: #0F0F0F;
	}
	* {
		padding: 0;
		margin: 0;
		list-style: none;
	}
	/*包含以下四种的链接*/
	a {
	    text-decoration: none;
	}
	/*正常的未被访问过的链接*/
	a:link {
	    text-decoration: none;
	}
	/*已经访问过的链接*/
	a:visited {
	    text-decoration: none;
	}
	/*鼠标划过(停留)的链接*/
	a:hover {
	    text-decoration: none;
	}
	/* 正在点击的链接*/
	a:active {
	    text-decoration: none;
	}
	
</style>



// WEBPACK FOOTER //
// src/App.vue